<template>
   <app-master>

       <div slot='breadcrumb'>
         <app-breadcrumb>
             <div class="title-box ttm-textcolor-white">
                <div class="page-title-heading">
                    <h1 class="title">Cash Crop Subscription</h1>
                </div><!-- /.page-title-captions -->
                <div class="breadcrumb-wrapper">
                    <div class="container">
                        <div class="breadcrumb-wrapper-inner">
                            <span>
                                <router-link class="home" title='Go to AgroPark' to='/'><i class="themifyicon ti-home"></i>&nbsp;&nbsp;Home </router-link>
            
                            </span>
                            <span class="ttm-bread-sep">&nbsp; | &nbsp;</span>
                            <span>Cash Crop Subscription</span>
                        </div>
                    </div>
                </div>
            </div>
         </app-breadcrumb>
       </div>
        



      <div slot='main_content'>

        

         <section class="ttm-row pb-50 clearfix">
            <div class="container">
                <!-- row -->
                <div class="row">
                    <div class="col-lg-12">
                        <!-- ttm-pf-single-content-wrapper-innerbox -->
                        <div class="ttm-pf-single-content-wrapper-innerbox ttm-pf-view-left-image">
                            <div class="ttm-pf-detail-box">
                                <div class="row">
                                    <div class="col-lg-8">
                                        <div class="ttm-featured-wrapper ttm-portfolio-featured-wrapper">
                                            <img class="img-fluid" src="/img/bigcash.png" alt="">
                                        </div>
                                    </div>
                                    <div class="col-lg-4">
                                        <div class="ttm-pf-single-detail-box res-991-mt-30">
                                            <div class="ttm-pf-detailbox">
                                                <ul class="ttm-pf-detailbox-list">
                                                    <li class="ttm-pf-details-date">
                                                        <span class="ttm-pf-left-details"><i class="fa fa-medkit"></i>Research Name </span>
                                                        <span class="ttm-pf-right-details">Vulputate Cursus</span>
                                                    </li>
                                                    <li class="ttm-pf-details-date">
                                                        <span class="ttm-pf-left-details"><i class="fa fa-user"></i> Patient </span>
                                                        <span class="ttm-pf-right-details">Andrew Bert</span>
                                                    </li>
                                                    <li class="ttm-pf-details-date">
                                                        <span class="ttm-pf-left-details"><i class="fa fa-user-md"></i>Doctor </span>
                                                        <span class="ttm-pf-right-details">Dr. Teresa Mayer</span>
                                                    </li>
                                                    <li class="ttm-pf-details-date">
                                                        <span class="ttm-pf-left-details"><i class="fa fa-stethoscope"></i>Category </span>
                                                        <span class="ttm-pf-right-details">Neurology</span>
                                                    </li>
                                                    <li class="ttm-pf-details-date">
                                                        <span class="ttm-pf-left-details"><i class="fa fa-calendar"></i>Date </span>
                                                        <span class="ttm-pf-right-details">25th November 2018</span>
                                                    </li>
                                                    <li class="ttm-pf-details-date">
                                                        <span class="ttm-pf-left-details"><i class="fa fa-map-marker"></i>Location </span>
                                                        <span class="ttm-pf-right-details">Bulls Stadium, Califorina</span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="ttm-pf-single-content-area">
                                <div class="ttm-portfolio-description">
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <h4>Did You Know?</h4>
                                            <div class="sep_holder_box width-100 mb-20">
                                                <span class="sep_holder"><span class="sep_line"></span></span>
                                                <span class="sep_holder"><span class="sep_line"></span></span>
                                            </div>
                                            <p>Cash Crop production is one of the pillars of nationalisation and foreign trade in any economy. Cash crops provide raw materials for the other sectors, thereby intensifying and extending employment opportunities to the majority. Local and foreign revenue made from cash crops can empower farm households to create savings and investments, as they facilitate agricultural innovations and development in rural areas. </p>
                                            <p> Please see the template for Oil palm & Cashew </p>
                                        </div>
                                    </div>
                                    <!-- row -->
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="pt-30">
                                                <h4>Subscription Template</h4>
                                                <div class="sep_holder_box width-100 mb-20">
                                                    <span class="sep_holder"><span class="sep_line"></span></span>
                                                    <span class="sep_holder"><span class="sep_line"></span></span>
                                                </div>
                                                <div class="row">
                                                    <div class="col-sm-6">
                                                        <ul class="ttm-list ttm-list-style-icon ttm-list-icon-color-skincolor">
                                                            <li><i class="fa fa-arrow-circle-right"></i><a href="https://www.agropark.com.ng/cash_crop_production_download/cashew/hectare/1/outright" > <span class="ttm-list-li-content"> Cashew Subsription Template</span> </a></li>
                                                            <li><i class="fa fa-arrow-circle-right"></i><a href="https://www.agropark.com.ng/cash_crop_production_download/oil%20palm/hectare/1/outright" > <span class="ttm-list-li-content"> Oil Palm Subsription Template </span> </a></li>
                                                            <!-- <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">combined with handful of model sentence and repudiated.</span></li>
                                                            <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">accusantium doloremque laudantium.</span></li> -->
                                                        </ul>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <ul class="ttm-list ttm-list-style-icon ttm-list-icon-color-skincolor">
                                                                          <li><i class="fa fa-arrow-circle-right"></i><a href="https://agropark.ng/asset-files/investment-breakdown.pptx" > <span class="ttm-list-li-content">You can download this investment breakdown for further details</span> </a></li>
                                                            <li><i class="fa fa-arrow-circle-right"></i><a href="https://www.app.agropark.ng/" > <span class="ttm-list-li-content">Please click on this link to submit an application</span> </a> </li>
                                                            <!-- <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">repudiated and annoyances Lorem ipsum dolor sit consectetur.</span></li>
                                                            <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">annoyances pain can procure him great pleasure ipsum sit.</span></li>
                                                            <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">combined with handful of model sentence and repudiated.</span></li>
                                                            <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">accusantium doloremque laudantium.</span></li> -->
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div><!-- row end-->
                                    <!-- row -->
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="pt-30">
                                                <h4>What to expect</h4>
                                                <div class="sep_holder_box width-100 mb-20">
                                                    <span class="sep_holder"><span class="sep_line"></span></span>
                                                    <span class="sep_holder"><span class="sep_line"></span></span>
                                                </div>
                                                <div class="row">
                                                    <div class="col-lg-12">
                                                        <p><img class="alignright img-fluid" src="/img/palm.png" alt="">Cash crop investment is a long-term lease plan (20 years). On one hectare of Oil Palm, there are spaces in between, which is summed up to 1 Acre. Subscribers have an option to cultivate Turmeric using this space.</p>
                                                         <p>You can earn profit on Turmeric (in 9 months) before your cash crop maturity.</p>
                                                      <h5>OIL PALM CULTIVATION </h5>
                                                      <div class="row">
                                                    <div class="col-sm-12">
                                                      <ul class="ttm-list ttm-list-style-icon ttm-list-icon-color-skincolor">
                                                            <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Oil Palm Investment Cost – N1,505,112.50 one off price,  you can also spread this amount through a period of 4 years.</span></li>
                                                            <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Total Payout to Subscriber: N19,253,486.88; The RoI is from the 4th year – 20th year.</span></li>
                                                            <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">The cost of one acre of Turmeric Investment: N330,480.00</span></li>
                                                            <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">RoI on Turmeric is remitted every 9months. This will sum up to 3 payouts before termination on the land. RoI on oil palm commences from the 4th year.</span></li> 
                                                            <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Payout in 1st & 2nd Years: N284,224.80; Payout in 3rd Year: N614,704.80</span></li>
                                                            <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Investment Tenure: 20 Years</span></li>
                                                        </ul>
                                                    </div>
                                                </div>

                                                <h5>CASHEW CULTIVATION</h5>
                                                      <div class="row">
                                                    <div class="col-sm-12">
                                                      <ul class="ttm-list ttm-list-style-icon ttm-list-icon-color-skincolor">
                                                            <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Cashew Investment Cost: N1,259,537.50</span></li>
                                                            <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Total Payout to Subscriber: N14,879,141.53 (RoI from the 4th year – 20th year)</span></li>
                                                            <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Turmeric Investment Cost – N330,480.00        </span></li>
                                                            <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Payout in 1st & 2nd Years: N284,224.80; Payout in 3rd Year: N614,704.80</span></li>
                                                            <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Investment Tenure: 20 Years</span></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="col-lg-12">
                                
                                <div class="ttm-nextprev-bottom-nav">
                                    <nav class="navigation post-navigation">
                                        <div class="nav-links">
                                            <div class="nav-previous"><a href="#" rel="prev"><span class="meta-nav" aria-hidden="true">Previous</span></a></div>
                                        </div>
                                    </nav>
                                </div>
                            </div> -->
                        </div><!-- ttm-pf-single-content-wrapper-innerbox end-->


                        <app-related-portfolio></app-related-portfolio>
                        
                    </div>
                </div>
            </div>
        </section>


        
      </div>

   </app-master>
</template>

<script>
// @ is an alias to /src
import Master from "@/components/Master.vue"
import Breadcrumb from "@/components/Breadcrumb.vue"
import RelatedPortfolio from "@/components/RelatedPortfolio.vue"
import { seo } from "../Repositories/seo"

export default {
  name: "Faq",
  mixins: [seo],
  components: {
    "app-master" : Master,
    "app-breadcrumb" : Breadcrumb,
    "app-related-portfolio": RelatedPortfolio

  },
  methods:{
     
  },
  created(){
      this.seoMetaData('Cash Crop Subscription', '');
  }

};
</script>


<style scoped>
  .show{
      display: block;
  }
</style>